"use client"

import { ComponentConfig } from "@measured/puck"
import { Spin } from "antd"
import { useState } from "react"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

// Interface for form props
export interface FormRegisterProps extends CommonStylesProps {
  NameForm: string
  Subtitle: string
  Email: string
}

export const RenderConfig: ComponentConfig<FormRegisterProps> = {
  render: ({ styles, responsiveType, className, NameForm, Subtitle, Email }) => {
    const id = `form-register-${Math.random().toString(36).substr(2, 9)}`

    const [formData, setFormData] = useState({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      position: "",
      CVURL: "",
      mySelf: "",
    })

    const [touchedFields, setTouchedFields] = useState({
      email: false,
      CVURL: false,
    })
    const [isPopupVisible, setIsPopupVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [message, setMessage] = useState("")
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target
      setFormData(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault()
      const errors = {
        email: !formData.email,
        CVURL: !formData.CVURL,
      }

      if (errors.email || errors.CVURL) {
        setTouchedFields(errors)
        setMessage("Vui lòng nhập đầy đủ thông tin bắt buộc!")
        return
      }
      setIsLoading(true)
      try {
        const response = await fetch("/api/email", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })

        if (!response.ok) {
          throw new Error("Failed to submit data")
        }

        setIsPopupVisible(true)
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          position: "",
          CVURL: "",
          mySelf: "",
        })
        setMessage("Đăng ký gian hàng thành công!")
      } catch (error) {
        console.error("Error:", error)
        setMessage("Đã xảy ra lỗi khi đăng ký!")
      } finally {
        setIsLoading(false)
      }
    }

    const handleBlur = (fieldName: string) => {
      setTouchedFields(prev => ({ ...prev, [fieldName]: true }))
    }

    const closePopup = () => {
      setIsPopupVisible(false)
    }

    const mergedStyles = {
      mobile: { ...styles?.mobile },
      tablet: { ...styles?.tablet },
      desktop: { ...styles?.desktop },
    }

    const responsiveCSS = generateResponsiveCSS(id, mergedStyles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={`${id} ${twMerge(className)} w-full `}>
          <div className="flex flex-col justify-between items-center sm:pt-[105px] sm:pb-[29px] pt-11 pb-5 sm:gap-0 gap-[6px]">
            <h2 className="text-[36px] leading-[50.4px] font-bold tracking-[1.8px] pb-[2px] max-sm:text-[22px] max-sm:tracking-[1.1px] max-sm:leading-[33px] max-sm:pb-[7px]">
              {NameForm}
            </h2>
            <p className="text-[16px]">{Subtitle}</p>
          </div>
          <div className="sm:px-[115px]">
            <form onSubmit={handleSubmit} className="flex flex-col gap-x-[30px]">
              <div className="flex sm:flex-row flex-col sm:gap-[30px] gap-2.5">
                <input
                  type="text"
                  name="name"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="First Name"
                  className="py-[3px] pr-[3px] pl-4 w-full bg-[#F9F9F9] placeholder:text-[#a69f9d] focus:outline-none h-[50px] sm:placeholder:text-sm placeholder:text-base placeholder:font-light"
                />
                <input
                  type="text"
                  name="name"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Last Name"
                  className="py-[3px] pr-[3px] pl-4 w-full bg-[#F9F9F9] placeholder:text-[#a69f9d] focus:outline-none h-[50px]"
                />
              </div>
              <div className="flex sm:flex-row flex-col sm:gap-[30px] gap-2.5 sm:py-[26px] py-2.5">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  onBlur={() => handleBlur("email")}
                  className={`py-[3px] pr-[3px] pl-4 w-full bg-[#F9F9F9] placeholder:text-[#a69f9d] focus:outline-none h-[50px] border-b ${
                    touchedFields.email && !formData.email ? "border-red-500" : "border-transparent"
                  }`}
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone"
                  className="py-[3px] pr-[3px] pl-4 w-full bg-[#F9F9F9] placeholder:text-[#a69f9d] focus:outline-none h-[50px]"
                />
              </div>
              <div className="flex sm:flex-row flex-col sm:gap-[30px] gap-2.5 sm:pb-[23px] pb-2.5">
                <select className="py-[3px] pr-6 pl-4 w-full bg-[#F9F9F9] h-[50px]" defaultValue="position">
                  <option value="position" disabled>
                    Position
                  </option>
                  <option value="Product Owner">Product Owner</option>
                  <option value="Game Developer (Senior)">Game Developer (Senior)</option>
                  <option value="UA Specialist (Junior/Middle)">UA Specialist (Junior/Middle)</option>
                </select>

                <input
                  type="text"
                  name="name"
                  value={formData.CVURL}
                  onChange={handleChange}
                  placeholder="CV URL"
                  onBlur={() => handleBlur("CVURL")}
                  className={`py-[3px] pr-[3px] pl-4 w-full bg-[#F9F9F9] placeholder:text-[#a69f9d] focus:outline-none h-[50px] border-b ${
                    touchedFields.CVURL && !formData.CVURL ? "border-red-500" : "border-transparent"
                  }`}
                  required
                />
              </div>
              <textarea
                name="company"
                value={formData.mySelf}
                onChange={handleChange}
                placeholder="Tell us a bit about yourself"
                className="pt-[10.5px] pb-[3px] pr-[10px] pl-4 w-full bg-[#F9F9F9] placeholder:text-[#a69f9d] focus:outline-none h-[126px] sm:mb-[37px] mb-[10px] resize-none"
              />
              <div className="flex justify-center sm:pb-[93px] pb-[54px]">
                <button
                  type="submit"
                  className="py-[8px] bg-[#3BC873] text-white font-medium leading-7 rounded-[40px] text-center whitespace-nowrap w-[168px] h-[42px] hover:bg-[#323232] text-[15px] max-sm:w-[120px] max-sm:font-medium"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>

          {isLoading && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <Spin />
            </div>
          )}

          {isPopupVisible && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-8 rounded shadow-md relative">
                <button
                  onClick={closePopup}
                  className="absolute top-0 text-[30px] right-2 text-gray-600 hover:text-gray-800"
                  aria-label="Close"
                >
                  &times;
                </button>
                <p className="text-lg font-semibold">{message}</p>
              </div>
            </div>
          )}
        </div>
      </>
    )
  },
}
